<template>
  <div class="ml-5" v-if="!isSmall">
    <px-top-menu-navigation-indicadores/>
    <px-top-menu-navigation-gestao-compras/>
    <px-top-menu-navigation-gestao-frete v-if="hasModuleGestorFrete"/>
    <px-top-menu-navigation-cadastros/>
    <px-top-menu-navigation-configuracoes/>
  </div>
</template>

<script>
import TopMenuNavigationIndicadores from '@/modules/navigation/TopMenuNavigationIndicadores.vue';
import TopMenuNavigationGestaoCompras
  from '@/modules/navigation/TopMenuNavigationGestaoCompras.vue';
import TopMenuNavigationGestaoFrete from '@/modules/navigation/TopMenuNavigationGestaoFrete.vue';
import TopMenuNavigationCadastros from '@/modules/navigation/TopMenuNavigationCadastros.vue';
import TopMenuNavigationConfiguracoes
  from '@/modules/navigation/TopMenuNavigationConfiguracoes.vue';
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters('user', ['user', 'hasModuleGestorFrete']),
    isSmall() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  components: {
    pxTopMenuNavigationIndicadores: TopMenuNavigationIndicadores,
    pxTopMenuNavigationGestaoCompras: TopMenuNavigationGestaoCompras,
    pxTopMenuNavigationGestaoFrete: TopMenuNavigationGestaoFrete,
    pxTopMenuNavigationCadastros: TopMenuNavigationCadastros,
    pxTopMenuNavigationConfiguracoes: TopMenuNavigationConfiguracoes,
  },
};
</script>
